import { IFoCaAn } from "../../../models/response/thuc-don/IFoCaAn";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";
export const objCaAnDefine = {
    LOAD_START: undefined,
    LOAD_SUCCESS: [] as IFoCaAn[],
    LOAD_ERROR: "",
    LOAD_COSO_START: 0,
    LOAD_COSO_SUCCESS: [] as IFoCaAn[],
    LOAD_COSO_ERROR: "",
    SHOW_EDIT_MODAL: {} as IFoCaAn | undefined,
    CLOSE_EDIT_MODAL: undefined,
    SAVE_START: {} as IFoCaAn,
    SAVE_SUCESS: {} as IFoCaAn,
    SAVE_ERROR: "",
    DELETE_START: 0,
    DELETE_SUCESS: undefined,
    DELETE_ERROR: ""
};

export const eFoCaAnActionTypeIds = generateActionTypeIds(objCaAnDefine, "CA_AN")
export type IFoCaAnActionTypes = IGenericActionType<typeof objCaAnDefine, "CA_AN">
